module.exports = __webpack_public_path__ + "static/media/pabbly.51cb50ff.webp";